import './ItemListSkeleton.css'

export default function ItemListSkeleton({
  isToken = false
}: {
  isToken?: boolean
}) {
  return (
    <ul id="item-list" className="item-list-skeleton skeleton-mode">
      {[1, 2, 3].map((item) => {
        return (
          <li key={item} className="item-skeleton">
            <section className="item-info">
              <span className="icon skeleton-pulse" />
              <h3 className="item-title">
                <span className="skeleton-pulse text-block" />
              </h3>
              <div className="item-meta">
                <div className="skeleton-pulse user-avatar" />
                <span className="skeleton-pulse text-block short" />
              </div>
            </section>
            <section className="item-actions">
              {!isToken ? (
                <span className="icon icon-star-stroke" />
              ) : (
                <span className="icon icon-dots" />
              )}
            </section>
          </li>
        )
      })}
    </ul>
  )
}
